import script from "./HomePageDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePageDashboard.vue?vue&type=script&setup=true&lang=js"

import "./HomePageDashboard.vue?vue&type=style&index=0&id=221852ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-221852ce"]])

export default __exports__